'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FaHome, FaGamepad, FaGift, FaUserPlus, FaStar, FaUser } from 'react-icons/fa';
import { useLanguage } from '@/contexts/LanguageContext';

interface MobileBottomNavProps {
  isAuthenticated: boolean;
}

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ isAuthenticated }) => {
  const { t } = useLanguage();
  const pathname = usePathname();

  const navItems = isAuthenticated ? [
    {
      href: '/',
      icon: FaHome,
      label: t('home'),
      key: 'home'
    },
    {
      href: '/games',
      icon: FaGamepad,
      label: t('games'),
      key: 'games'
    },
    {
      href: '/promotions',
      icon: FaGift,
      label: t('promotions'),
      key: 'promotions'
    },
    {
      href: '/invite',
      icon: FaUserPlus,
      label: t('invite'),
      key: 'invite'
    },
    {
      href: '/profile',
      icon: FaUser,
      label: t('account'),
      key: 'account'
    }
  ] : [
    {
      href: '/',
      icon: FaHome,
      label: t('home'),
      key: 'home'
    },
    {
      href: '/games',
      icon: FaGamepad,
      label: t('games'),
      key: 'games'
    },
    {
      href: '/promotions',
      icon: FaGift,
      label: t('promotions'),
      key: 'promotions'
    },
    {
      href: '/login',
      icon: FaUser,
      label: t('login'),
      key: 'login'
    },
    {
      href: '/register',
      icon: FaUserPlus,
      label: t('register'),
      key: 'register'
    }
  ];

  const isActive = (href: string, key: string) => {
    if (href === '/') {
      return pathname === '/';
    }
    return pathname.startsWith(href);
  };

  return (
    <nav className="mobile-bottom-nav">
      <div className="mobile-bottom-nav-container">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.href, item.key);
          
          return (
            <Link
              key={item.key}
              href={item.href}
              className={`mobile-nav-item ${active ? 'active' : ''}`}
            >
              <Icon className="mobile-nav-icon" />
              <span className="mobile-nav-text">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
